import {UmpireArticleLink} from '../umpire-article-link';
import {UmpireCustomLink} from '../umpire-custom-link';
import {UmpirePageTypeLink} from '../umpire-page-type-link';

export type UmpireLinkData = UmpirePageTypeLink | UmpireArticleLink | UmpireCustomLink;

export interface UmpireLink {
  id: string;
  index: number;
  resource: {
    data: UmpireLinkData;
  };
  type: 'link';
}
